import parsePhoneNumber from "libphonenumber-js";

export function formatPhoneNumber(value: string): string {
  try {
    const phoneNumber = parsePhoneNumber(value.startsWith("+") ? value : `+${value}`);
    return phoneNumber?.isValid() ? phoneNumber.formatInternational() : value;
  } catch {
    return value;
  }
}
